// extracted by mini-css-extract-plugin
export default {"profileBox":"profileBox__1PhNd","userName":"userName__vUS-8","links":"links__2vAW8","profileBoxLink":"profileBoxLink__2mv0e"};